import { postLogin, postLogout } from '../api/AccessApi';

export const userLogin = (email, password) => async (dispatch) => {
    try {
        const result = await postLogin(email, password);
        if (result?.data) dispatch({ type: 'LOGIN', payload: result.data });
        else if (result?.error) {
            let notify = { msg: result.error, theme: 'error' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
        }
    } catch (error) {
        return error;
    }
};

export const loginReset = () => async (dispatch) => {
    try {
        dispatch({ type: 'LOGIN_RESET', payload: '' });
    } catch (error) {
        return error;
    }
};

export const userLogout = (id) => async (dispatch) => {
    try {
        const result = await postLogout(id);
        if (result?.data) dispatch({ type: 'LOGOUT', payload: result.data });
        else if (result?.error) {
            let notify = { msg: result.error, theme: 'error' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
        }
    } catch (error) {
        return error;
    }
};
